// === Primeiro gesto → html.gestured (05/09) ===
// Os trilhos com scroll-snap se auto-ajustavam no carregamento; o Chrome
// tratava como scroll e PARAVA de medir o LCP (celular sem nota no
// PageSpeed). O CSS só liga snap/rolagem-suave depois do 1º gesto real.
(function () {
  function g() { document.documentElement.classList.add('gestured'); }
  ['scroll', 'touchstart', 'pointerdown', 'keydown', 'mousemove', 'wheel'].forEach(function (ev) {
    window.addEventListener(ev, g, { once: true, passive: true });
  });
})();

// === Order Bump stubs (available before IIFE loads) ===
// These get overwritten by the IIFE with real implementations
function selectBumpVariant() {}
function toggleOrderBump() {}

(function() {
  'use strict';

  // Product variants (injected by Liquid in product-hero section)
  let selectedVariantId = null;
  let currentBundleEl = null;

  // === Mapa de precos (localStorage) ===
  // Substitui as line item properties (_compare_at/_pix/_installment/_savings).
  // Antes esses dados iam no carrinho e VAZAVAM no checkout Yever / pedido / Bling.
  // Agora ficam so no navegador, pro drawer calcular a vista/12x/economia.
  var YELLA_PRICING_KEY = 'yella_pricing_map';
  function yellaReadPricing() {
    try { return JSON.parse(localStorage.getItem(YELLA_PRICING_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function yellaSavePricing(variantId, data) {
    if (!variantId) return;
    try {
      var map = yellaReadPricing();
      map[variantId] = data;
      localStorage.setItem(YELLA_PRICING_KEY, JSON.stringify(map));
    } catch (e) {}
  }
  function yellaGetPricing(variantId) {
    var map = yellaReadPricing();
    return map[variantId] || null;
  }

  // === GA4 / dataLayer — eventos de funil (view_item, add_to_cart) ===
  function yellaItemFromEl(el) {
    if (!el) return null;
    var priceStr = (el.dataset.price || '').replace('R$', '').trim();
    var cents = priceStr ? parseMoney(priceStr) : 0;
    var variant = ((el.dataset.bundleLabel || '') + ' ' + (el.dataset.desc || '')).trim();
    return {
      item_id: String(el.dataset.variantId || ''),
      item_name: 'Seja Leve',
      item_variant: variant,
      price: cents ? cents / 100 : 0,
      quantity: 1
    };
  }
  function yellaEcommerce(eventName, items) {
    items = (items || []).filter(Boolean);
    if (!items.length) return;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      var value = 0;
      for (var i = 0; i < items.length; i++) {
        value += (items[i].price || 0) * (items[i].quantity || 1);
      }
      window.dataLayer.push({
        event: eventName,
        ecommerce: { currency: 'BRL', value: value, items: items }
      });
    } catch (e) {}
  }

  // === Error Toast ===
  function showErrorToast(msg) {
    var existing = document.getElementById('errorToast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'errorToast';
    toast.style.cssText = 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:#ef4444;color:#fff;padding:12px 24px;border-radius:12px;font-size:14px;font-weight:600;z-index:9999;box-shadow:0 4px 12px rgba(0,0,0,0.15);transition:opacity 0.3s;';
    toast.textContent = msg;
    document.body.appendChild(toast);
    setTimeout(function() { toast.style.opacity = '0'; setTimeout(function() { toast.remove(); }, 300); }, 4000);
  }

  // === Cart Functions (native Shopify) ===
  function addToCart(variantId) {
    if (!variantId) { showErrorToast('Selecione uma opção'); return; }
    var btn = document.getElementById('mainCta');
    if (btn) { btn.disabled = true; btn.textContent = 'Adicionando...'; }

    // Get compare/pix/installment from active bundle card (para o carrinho calcular certo)
    var compareAt = '';
    var savings = '';
    var pixCents = '';
    var instCents = '';
    if (currentBundleEl) {
      compareAt = currentBundleEl.dataset.comparePrice || '';
      savings = currentBundleEl.dataset.savings || '';
      pixCents = currentBundleEl.dataset.pixCents || '';
      instCents = currentBundleEl.dataset.instCents || '';
    }

    var itemData = { id: variantId, quantity: 1 };
    // Guarda os precos no localStorage (NAO em line item properties, pra nao vazar no checkout Yever)
    yellaSavePricing(variantId, {
      c: compareAt ? parseMoney(compareAt) : 0,
      s: savings || '',
      p: pixCents ? parseInt(pixCents, 10) : 0,
      i: instCents ? parseInt(instCents, 10) : 0
    });

    var dlItem = yellaItemFromEl(currentBundleEl);
    if (dlItem) dlItem.item_id = String(variantId);

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function() {
      if (btn) { btn.disabled = false; btn.textContent = 'COMPRAR AGORA'; }
      yellaEcommerce('add_to_cart', [dlItem]);
      fetchCart();
      openCartDrawer();
    };
    xhr.onerror = function() {
      if (btn) { btn.disabled = false; btn.textContent = 'COMPRAR AGORA'; }
      fetchCart();
      openCartDrawer();
    };
    xhr.send(JSON.stringify({ items: [itemData] }));
  }

  // === Cart Drawer ===
  function openCartDrawer() {
    document.getElementById('cartDrawerOverlay').classList.add('open');
    document.getElementById('cartDrawer').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    document.getElementById('cartDrawerOverlay').classList.remove('open');
    document.getElementById('cartDrawer').classList.remove('open');
    document.body.style.overflow = '';
  }

  function fetchCart() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function() {
      if (xhr.status === 200) {
        try { renderCartDrawer(JSON.parse(xhr.responseText)); } catch(e) {}
      }
    };
    xhr.send();
  }

  function renderCartDrawer(cart) {
    const itemsEl = document.getElementById('cartDrawerItems');
    const emptyEl = document.getElementById('cartDrawerEmpty');
    const footerEl = document.getElementById('cartDrawerFooter');
    const countEl = document.getElementById('cartDrawerCount');
    const subtotalEl = document.getElementById('cartDrawerSubtotal');

    // Update header badge
    updateCartBadge(cart.item_count);
    if (countEl) countEl.textContent = cart.item_count;

    if (!cart.items.length) {
      itemsEl.classList.add('hidden');
      footerEl.classList.add('hidden');
      emptyEl.classList.remove('hidden');
      var shippingBar = document.getElementById('shippingProgressBar');
      if (shippingBar) shippingBar.classList.add('hidden');
      var bumpEl = document.getElementById('orderBump');
      if (bumpEl) bumpEl.classList.add('hidden');
      return;
    }

    itemsEl.classList.remove('hidden');
    footerEl.classList.remove('hidden');
    emptyEl.classList.add('hidden');

    var cfg = window.theme_cart_config || {};
    var fsMinQty = parseInt(cfg.free_shipping_min_quantity, 10) || 0;
    var fsThreshold = parseInt(cfg.free_shipping_threshold, 10) || 0;
    var instMax = parseInt(cfg.installments_max, 10) || 12;

    // Soma os valores REAIS de cada kit (Pix a vista + parcela 12x), com fallback
    var pixTotal = 0, instTotal = 0, totalSavings = 0;
    cart.items.forEach(function(item) {
      var qty = item.quantity;
      var pricing = yellaGetPricing(item.variant_id) || {};
      var pixc = pricing.p || 0;
      var instc = pricing.i || 0;
      var comparec = pricing.c || 0;
      // a vista = Pix do item; senao o preco de linha do carrinho
      pixTotal += pixc ? pixc * qty : item.final_line_price;
      // 12x = parcela real do item; senao divide o preco de linha
      instTotal += instc ? instc * qty : Math.round(item.final_line_price / instMax);
      // economizou = compare - a vista (Pix) por unidade
      var unitAvista = pixc ? pixc : item.final_price;
      if (comparec > unitAvista) totalSavings += (comparec - unitAvista) * qty;
    });

    if (subtotalEl) subtotalEl.textContent = formatMoney(pixTotal);

    var freeShipEl = document.getElementById('cartDrawerFreeShipping');
    var progressFill = document.getElementById('cartDrawerProgressFill');
    if (freeShipEl) {
      var qualifies = false;
      if (fsMinQty > 0) qualifies = cart.item_count >= fsMinQty;
      else if (fsThreshold > 0) qualifies = cart.total_price >= fsThreshold;
      freeShipEl.classList.toggle('hidden', !qualifies);
      if (progressFill) progressFill.style.width = qualifies ? '100%' : '0%';
    }

    var instEl = document.getElementById('cartDrawerInstallments');
    if (instEl) {
      if (instTotal > 0) {
        instEl.textContent = 'em até ' + instMax + 'x de ' + formatMoney(instTotal) + ' no cartão';
        instEl.classList.remove('hidden');
      } else {
        instEl.classList.add('hidden');
      }
    }

    var savingsEl = document.getElementById('cartDrawerSavings');
    var savingsAmountEl = document.getElementById('cartDrawerSavingsAmount');
    if (savingsEl) {
      totalSavings = Math.round(totalSavings);
      if (totalSavings >= 1) {
        if (savingsAmountEl) savingsAmountEl.textContent = formatMoney(totalSavings);
        savingsEl.classList.remove('hidden');
        savingsEl.style.display = '';
      } else {
        savingsEl.classList.add('hidden');
        savingsEl.style.display = 'none';
      }
    }

    renderShippingBar(cart);
    renderCartUpsell(cart);

    // Get bump product ID to exclude from regular items list
    var bumpEl = document.getElementById('orderBump');
    var bumpProductId = bumpEl ? parseInt(bumpEl.dataset.productId) : 0;

    // If only bump items remain, auto-remove them and show empty state
    var mainItems = cart.items.filter(function(item) { return item.product_id !== bumpProductId; });
    if (bumpProductId && !mainItems.length && cart.items.length > 0) {
      cart.items.forEach(function(item) {
        if (item.product_id === bumpProductId) {
          var rmXhr = new XMLHttpRequest();
          rmXhr.open('POST', '/cart/change.js', true);
          rmXhr.setRequestHeader('Content-Type', 'application/json');
          rmXhr.onload = function() { fetchCart(); };
          rmXhr.send(JSON.stringify({ id: item.key, quantity: 0 }));
        }
      });
      return;
    }

    itemsEl.innerHTML = cart.items.filter(function(item) {
      return item.product_id !== bumpProductId;
    }).map(item => {
      var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_small$1') : '';
      var variantTitle = item.variant_title || '';
      return '<div class="cart-drawer-item">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '">' : '') +
        '<div class="flex-1 min-w-0">' +
          '<p class="text-sm font-medium text-gray-800 truncate">' + escapeHtml(item.product_title) + '</p>' +
          (variantTitle ? '<p class="text-xs text-gray-500 mt-0.5">' + escapeHtml(variantTitle) + '</p>' : '') +
          '<div class="mt-1">' +
            '<span class="text-sm font-semibold text-gray-800">' + formatMoney(item.final_line_price) + '</span>' +
            ((yellaGetPricing(item.variant_id) || {}).c ?
              (function() {
                var cVal = (yellaGetPricing(item.variant_id) || {}).c || 0;
                return ' <span class="text-xs text-gray-400 line-through">' + formatMoney(cVal * item.quantity) + '</span>';
              })()
            : (item.original_line_price > item.final_line_price ?
              ' <span class="text-xs text-gray-400 line-through">' + formatMoney(item.original_line_price) + '</span>'
            : '')) +
          '</div>' +
          '<div class="flex items-center justify-between mt-2">' +
            '<div class="cart-drawer-qty">' +
              '<button onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity - 1) + ')" aria-label="Decrease">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity + 1) + ')" aria-label="Increase">+</button>' +
            '</div>' +
            '<button onclick="removeCartItem(\'' + item.key + '\')" class="text-gray-400 hover:text-red-500 transition" aria-label="Remove">' +
              '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  var cartBusy = false;
  function updateCartItem(key, qty) {
    // Chave ausente/obsoleta: nada a fazer, so re-sincroniza o estado real
    if (!key) { fetchCart(); return; }
    // Trava contra cliques concorrentes/duplo-toque (evita 2o change.js com linha ja removida)
    if (cartBusy) return;
    if (qty < 0) qty = 0;
    cartBusy = true;
    // Desabilita os botoes da gaveta enquanto a requisicao esta em voo
    var itemsEl = document.getElementById('cartDrawerItems');
    if (itemsEl) itemsEl.querySelectorAll('button').forEach(function(b) { b.disabled = true; });
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/change.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function() {
      cartBusy = false;
      if (xhr.status >= 400) {
        // Linha obsoleta (ja alterada por um toque anterior): re-sincroniza sem assustar o cliente
        if (xhr.status === 404 || /no valid id or line/i.test(xhr.responseText)) {
          fetchCart();
          return;
        }
        var msg = 'Erro ao atualizar';
        try {
          var r = JSON.parse(xhr.responseText);
          msg = r.description || r.message || (r.errors && JSON.stringify(r.errors)) || msg;
        } catch(e) {}
        showErrorToast('[' + xhr.status + '] ' + msg);
      }
      fetchCart();
    };
    xhr.onerror = function() { cartBusy = false; showErrorToast('Falha de rede ao atualizar'); fetchCart(); };
    xhr.send(JSON.stringify({ id: key, quantity: qty }));
  }

  function removeCartItem(key) {
    updateCartItem(key, 0);
  }

  function updateCartBadge(count) {
    document.querySelectorAll('.cart-count, .cart-count-mobile').forEach(badge => {
      badge.textContent = count;
      badge.classList.toggle('hidden', count === 0);
    });
  }

  function parseMoney(str) {
    if (typeof str === 'number') return Math.round(str);
    if (!str) return 0;
    var s = String(str).replace(/[^0-9.,]/g, '');
    if (!s) return 0;
    var lastDot = s.lastIndexOf('.');
    var lastComma = s.lastIndexOf(',');
    if (lastDot === -1 && lastComma === -1) {
      return parseInt(s, 10) * 100;
    }
    var decSep, thouSep;
    if (lastDot > lastComma) { decSep = '.'; thouSep = ','; }
    else                     { decSep = ','; thouSep = '.'; }
    s = s.split(thouSep).join('').replace(decSep, '.');
    return Math.round(parseFloat(s) * 100);
  }

  function formatMoney(cents) {
    cents = Number(cents) || 0;
    var format = window.theme_money_format || '${{amount}}';
    function group(value, thousands, decimal, decimals) {
      var num = (cents / 100).toFixed(decimals);
      var parts = num.split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals > 0 ? intPart + decimal + parts[1] : intPart;
    }
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, group(cents, ',', '.', 2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(cents, ',', '.', 0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, group(cents, '.', ',', 2))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, group(cents, '.', ',', 0))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, group(cents, ' ', ',', 2))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, group(cents, ' ', ',', 0))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, group(cents, "'", '.', 2))
      .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/g, group(cents, ' ', '.', 2));
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  // === Bundle Selection ===
  function selectBundle(el) {
    document.querySelectorAll('.bundle-card').forEach(c => c.classList.remove('active'));
    el.classList.add('active');
    const radio = el.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;
    currentBundleEl = el;
    selectedVariantId = parseInt(el.dataset.variantId);
    try { if (selectedVariantId) localStorage.setItem('yella_bundle_variant', String(selectedVariantId)); } catch(e){}

    // Update hero price display
    const heroPrice = document.getElementById('heroPrice');
    const heroOldPrice = document.getElementById('heroOldPrice');
    const heroDiscount = document.getElementById('heroDiscount');
    const heroDesc = document.getElementById('heroDesc');
    const heroImg = document.getElementById('heroProductImg');

    if (heroPrice) heroPrice.textContent = el.dataset.price;
    if (heroOldPrice) heroOldPrice.textContent = el.dataset.comparePrice;
    if (heroDiscount) heroDiscount.textContent = el.dataset.savings;
    if (heroDesc) heroDesc.textContent = el.dataset.desc;
    if (heroImg && el.dataset.img) { heroImg.src = el.dataset.img; heroImg.removeAttribute('srcset'); }

    // Update sticky bar: kit certo (label + sabores) + a vista (Pix) + 12x
    const stickyPrice = document.getElementById('stickyPrice');
    const stickyTitle = document.getElementById('stickyTitle');
    const stickyInstallment = document.getElementById('stickyInstallment');
    const stickyDuration = document.getElementById('stickyDuration');

    if (stickyPrice) stickyPrice.textContent = el.dataset.pix || el.dataset.price;
    if (stickyTitle) stickyTitle.textContent = el.dataset.bundleLabel || el.dataset.title;
    if (stickyDuration) stickyDuration.textContent = el.dataset.desc || '';
    if (stickyInstallment) {
      if (el.dataset.installment) {
        var instM = el.dataset.installment.match(/^(\d+x)\s+de\s+(.+)$/);
        if (instM) stickyInstallment.innerHTML = 'ou <strong>' + instM[1] + '</strong> de <strong>' + instM[2] + '</strong>';
        else stickyInstallment.textContent = 'ou ' + el.dataset.installment;
      } else {
        stickyInstallment.textContent = '';
      }
    }

    // Frete Grátis só a partir de 2 potes (some no 1 pote)
    var stickyShip = document.getElementById('stickyShip');
    if (stickyShip) {
      var qm = (el.dataset.bundleLabel || el.dataset.title || '').match(/(\d+)/);
      var qty = qm ? parseInt(qm[1], 10) : 0;
      stickyShip.style.display = qty >= 2 ? '' : 'none';
    }
  }

  // === Gallery ===
  let currentImageIndex = 0;
  function navigateHeroImage(dir) {
    const imgs = document.querySelectorAll('#heroThumbnails .thumb-item');
    if (!imgs.length) return;
    currentImageIndex += dir;
    if (currentImageIndex < 0) currentImageIndex = imgs.length - 1;
    if (currentImageIndex >= imgs.length) currentImageIndex = 0;
    selectGalleryImage(currentImageIndex);
  }

  function selectGalleryImage(index) {
    currentImageIndex = index;
    const thumbs = document.querySelectorAll('#heroThumbnails .thumb-item');
    const heroImg = document.getElementById('heroProductImg');
    if (thumbs[index]) {
      const img = thumbs[index].querySelector('img');
      if (img && heroImg) {
        var newSrc = img.dataset.fullSrc || img.src;
        heroImg.src = newSrc;
        heroImg.removeAttribute('srcset');
      }
    }
    thumbs.forEach((t, i) => {
      t.classList.toggle('border-primary', i === index);
      t.classList.toggle('border-transparent', i !== index);
      if (i === index) t.classList.add('bg-primary-light/30');
      else t.classList.remove('bg-primary-light/30');
    });
  }

  // === FAQ Accordion ===
  function toggleFaq(btn) {
    const answer = btn.nextElementSibling;
    const chevron = btn.querySelector('.faq-chevron');
    const isOpen = answer.classList.contains('open');
    // Close all
    document.querySelectorAll('.faq-answer').forEach(a => { a.classList.remove('open'); a.style.maxHeight = '0'; });
    document.querySelectorAll('.faq-chevron').forEach(c => c.classList.remove('open'));
    // Open clicked if was closed
    if (!isOpen) {
      answer.classList.add('open');
      answer.style.maxHeight = answer.scrollHeight + 20 + 'px';
      chevron.classList.add('open');
    }
  }

  // === Info Tabs (Problems/Benefits/Specs) ===
  function switchInfoTab(tabId) {
    document.querySelectorAll('.info-tab-content').forEach(c => c.classList.add('hidden'));
    document.querySelectorAll('.info-tab').forEach(t => t.classList.remove('info-tab-active'));
    const tab = document.getElementById(tabId);
    if (tab) tab.classList.remove('hidden');
    if (event && event.currentTarget) event.currentTarget.classList.add('info-tab-active');
  }

  // === Before/After Tabs (CyperSilk) ===
  function switchBATab(tabId) {
    document.querySelectorAll('.ba-tab-content').forEach(c => c.classList.add('hidden'));
    document.querySelectorAll('.ba-tab').forEach(t => t.classList.remove('ba-tab-active'));
    const tab = document.getElementById(tabId);
    if (tab) tab.classList.remove('hidden');
    if (event && event.currentTarget) event.currentTarget.classList.add('ba-tab-active');
  }

  // === Video Modal ===
  function openVideoModal(ytId) {
    const modal = document.getElementById('videoModal');
    const iframe = document.getElementById('modalYoutube');
    if (!modal || !iframe) return;
    iframe.src = 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0';
    modal.classList.remove('hidden');
    modal.classList.add('flex');
  }

  function closeVideoModal(e) {
    if (e && e.target !== e.currentTarget) return;
    const modal = document.getElementById('videoModal');
    const iframe = document.getElementById('modalYoutube');
    if (iframe) iframe.src = '';
    if (modal) { modal.classList.add('hidden'); modal.classList.remove('flex'); }
  }

  // === Mobile Menu ===
  function toggleMobileMenu() {
    const menu = document.getElementById('mobileMenu');
    const iconOpen = document.getElementById('menuIconOpen');
    const iconClose = document.getElementById('menuIconClose');
    if (!menu) return;
    const isOpen = menu.classList.contains('open');
    menu.classList.toggle('open', !isOpen);
    if (iconOpen) iconOpen.classList.toggle('hidden', !isOpen);
    if (iconClose) iconClose.classList.toggle('hidden', isOpen);
  }

  // === Scroll Behaviors ===
  function initScrollBehaviors() {
    const stickyBar = document.getElementById('sticky-bar');
    const header = document.getElementById('main-header');
    const bttBtn = document.getElementById('backToTopBtn');
    const sections = document.querySelectorAll('section[id]');
    const tabBtns = document.querySelectorAll('.tab-btn');
    let ticking = false;

    // Cache section offsets to avoid layout thrashing on scroll
    let sectionOffsets = [];
    function cacheSectionOffsets() {
      sectionOffsets = [];
      sections.forEach(s => { sectionOffsets.push({ id: s.id, top: s.offsetTop }); });
    }
    cacheSectionOffsets();
    var resizeTimer = null;
    window.addEventListener('resize', function() {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(cacheSectionOffsets, 150);
    });

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const y = window.scrollY;
          if (stickyBar) stickyBar.classList.toggle('visible', y > 350);
          if (header) header.classList.toggle('scrolled', y > 10);
          if (bttBtn) bttBtn.classList.toggle('visible', y > 500);
          if (tabBtns.length) {
            let current = '';
            for (var i = 0; i < sectionOffsets.length; i++) {
              if (y >= sectionOffsets[i].top - 120) current = sectionOffsets[i].id;
            }
            tabBtns.forEach(b => { b.classList.toggle('active', b.getAttribute('href') === '#' + current); });
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // === Reveal Animations ===
  function initRevealAnimations() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale, .reveal-stagger')
      .forEach(el => observer.observe(el));
  }

  // === Animated Counters ===
  function initCounters() {
    let animated = false;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !animated) {
          animated = true;
          document.querySelectorAll('.counter').forEach(counter => {
            const target = parseInt(counter.dataset.target);
            let current = 0;
            const step = target / 125;
            const update = () => {
              current += step;
              if (current < target) {
                counter.textContent = Math.floor(current) + '%';
                requestAnimationFrame(update);
              } else {
                counter.textContent = target + '%';
              }
            };
            update();
          });
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.counter').forEach(c => observer.observe(c));
  }

  // === Video Story Buttons ===
  function initVideoStories() {
    document.querySelectorAll('.video-story-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const ytId = btn.getAttribute('data-youtube');
        if (ytId) openVideoModal(ytId);
      });
    });
  }

  // === Checkout ===
  function shopifyCheckout() {
    // Comprar Agora abre o carrinho (1 kit por vez). O checkout Yever ocorre no botao Finalizar Compra.
    var el = currentBundleEl || document.querySelector('.bundle-card.active');
    var vid = selectedVariantId || (el ? parseInt(el.dataset.variantId) : 0);
    if (vid) addToCart(vid);
    else showErrorToast('Selecione uma opção');
  }

  // === Announcement Bar ===
  function initAnnouncementBar() {
    var bar = document.getElementById('announcementBar');
    if (!bar) return;
    if (getCookie('announcement_dismissed')) { bar.style.display = 'none'; return; }
    var msgs = bar.querySelectorAll('.announcement-msg');
    if (msgs.length < 2) return;
    var current = 0;
    var interval = parseInt(bar.dataset.interval) || 4000;

    // Pause rotation during scroll to avoid repaints
    var annScrolling = false;
    var annScrollTimer = null;
    window.addEventListener('scroll', function() {
      annScrolling = true;
      if (annScrollTimer) clearTimeout(annScrollTimer);
      annScrollTimer = setTimeout(function() { annScrolling = false; }, 200);
    }, { passive: true });

    var annIntervalId = setInterval(function() {
      if (annScrolling || document.hidden) return;
      msgs[current].classList.add('announcement-fade-out');
      setTimeout(function() {
        msgs[current].classList.add('hidden');
        msgs[current].classList.remove('announcement-fade-out');
        current = (current + 1) % msgs.length;
        msgs[current].classList.remove('hidden');
        msgs[current].classList.add('announcement-fade-out');
        requestAnimationFrame(function() { msgs[current].classList.remove('announcement-fade-out'); });
      }, 300);
    }, interval);
  }

  function dismissAnnouncement() {
    var bar = document.getElementById('announcementBar');
    if (bar) { bar.style.display = 'none'; setCookie('announcement_dismissed', '1', 1); }
  }

  // === Countdown Timer ===
  function initCountdownTimer() {
    var display = document.getElementById('countdownDisplay');
    if (!display) return;
    var key = 'countdown_end';
    var stored = sessionStorage.getItem(key);
    var endTime;
    if (stored) {
      endTime = parseInt(stored);
    } else {
      endTime = Date.now() + 7200000; // 2 hours
      sessionStorage.setItem(key, endTime);
    }
    var timerId = null;
    function tick() {
      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        endTime = Date.now() + 7200000;
        sessionStorage.setItem(key, endTime);
        remaining = 7200000;
      }
      var h = Math.floor(remaining / 3600000);
      var m = Math.floor((remaining % 3600000) / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      display.textContent = String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    }
    tick();
    // Pause timer DOM updates when countdown is off-screen
    var observer = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        if (!timerId) { tick(); timerId = setInterval(tick, 1000); }
      } else {
        if (timerId) { clearInterval(timerId); timerId = null; }
      }
    });
    observer.observe(display);
  }

  // === Social Proof Toasts ===
  function initSocialProofToasts() {
    var toast = document.getElementById('socialProofToast');
    var msgEl = document.getElementById('toastMessage');
    if (!toast || !msgEl || !window._toastData) return;
    var data = window._toastData;
    var dismissed = false;
    var dismissedAt = parseInt(sessionStorage.getItem('toast_dismissed_at') || '0');
    if (dismissedAt && Date.now() - dismissedAt < 300000) return; // 5 min suppress

    // Suppress toasts during active scroll to avoid jank
    var isScrolling = false;
    var scrollTimer = null;
    window.addEventListener('scroll', function() {
      isScrolling = true;
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() { isScrolling = false; }, 150);
    }, { passive: true });

    function showRandomToast() {
      if (dismissed || window._popupShown || isScrolling || document.hidden) return;
      var item = data[Math.floor(Math.random() * data.length)];
      msgEl.textContent = item.name + ' de ' + item.city + ' acabou de comprar ' + item.product;
      toast.style.display = 'block';
      requestAnimationFrame(function() { toast.classList.add('visible'); });
      setTimeout(function() {
        toast.classList.remove('visible');
        setTimeout(function() { toast.style.display = 'none'; }, 400);
      }, 5000);
    }

    // First toast after 10s delay
    var firstDelay = sessionStorage.getItem('toast_shown') ? 0 : 10000;
    sessionStorage.setItem('toast_shown', '1');
    var toastIntervalId = null;
    setTimeout(function() {
      showRandomToast();
      toastIntervalId = setInterval(function() {
        var delay = 20000 + Math.random() * 10000; // 20-30s
        setTimeout(showRandomToast, delay);
      }, 30000);
    }, firstDelay);

    window.dismissToast = function() {
      dismissed = true;
      if (toastIntervalId) { clearInterval(toastIntervalId); toastIntervalId = null; }
      toast.classList.remove('visible');
      setTimeout(function() { toast.style.display = 'none'; }, 400);
      sessionStorage.setItem('toast_dismissed_at', String(Date.now()));
    };
  }

  // === Free Shipping Progress Bar ===
  function renderShippingBar(cart) {
    var barEl = document.getElementById('shippingProgressBar');
    var textEl = document.getElementById('shippingProgressText');
    var fillEl = document.getElementById('shippingProgressFill');
    if (!barEl || !textEl || !fillEl) return;
    barEl.classList.remove('hidden');
    var threshold = parseInt(barEl.dataset.threshold) || 0;
    var total = cart.total_price;
    var remaining = threshold - total;
    if (remaining <= 0) {
      textEl.innerHTML = '<span class="inline-flex items-center justify-center gap-1"><svg class="w-4 h-4 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg> Parabéns! Você ganhou <strong>FRETE GRÁTIS!</strong></span>';
      fillEl.style.width = '100%';
    } else {
      textEl.innerHTML = "Faltam <strong>" + formatMoney(remaining) + "</strong> para FRETE GRÁTIS!";
      fillEl.style.width = Math.min((total / threshold) * 100, 100) + '%';
    }
  }

  // === Discount Code ===
  function toggleDiscountField() {
    var field = document.getElementById('discountFieldWrapper');
    if (field) field.classList.toggle('hidden');
  }

  function applyDiscountCode() {
    var input = document.getElementById('discountCodeInput');
    if (!input || !input.value.trim()) return;
    window.location.href = '/discount/' + encodeURIComponent(input.value.trim()) + '?redirect=/checkout';
  }

  // === Order Bump ===
  var _bumpEl = document.getElementById('orderBump');
  var _bumpVariantId = _bumpEl ? parseInt(_bumpEl.dataset.firstVariant || '0') : 0;
  var _bumpPrice = _bumpEl ? parseInt(_bumpEl.dataset.firstPrice || '0') : 0;
  var _bumpCompare = _bumpEl ? parseInt(_bumpEl.dataset.compare || '0') : 0;

  function selectBumpVariant(variantId, price, btn) {
    var oldVariantId = _bumpVariantId;
    _bumpVariantId = variantId;
    _bumpPrice = price;
    var priceEl = document.getElementById('orderBumpPrice');
    var compareEl = document.getElementById('orderBumpCompare');
    var discountEl = document.getElementById('orderBumpDiscount');
    if (priceEl) priceEl.textContent = formatMoney(price);
    if (compareEl && _bumpCompare > 0) compareEl.textContent = formatMoney(_bumpCompare);
    var pct = _bumpCompare > 0 ? Math.round((1 - price / _bumpCompare) * 100) : 0;
    if (discountEl && pct > 0) discountEl.textContent = pct + '% OFF';
    document.querySelectorAll('.bump-variant-btn').forEach(function(b) {
      b.style.borderColor = '#d1d5db';
      b.style.color = '#6b7280';
      b.style.background = 'white';
    });
    // Swap product image based on selected variant
    var bumpImg = document.getElementById('orderBumpImg');
    var bumpEl = document.getElementById('orderBump');
    if (bumpImg && bumpEl && btn) {
      // data-img-fine -> dataset.imgFine, data-img-coarse -> dataset.imgCoarse
      var handle = btn.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      var key = 'img' + handle.split('-').map(function(w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join('');
      if (bumpEl.dataset[key]) bumpImg.src = bumpEl.dataset[key];
    }
    if (btn) {
      btn.style.borderColor = 'var(--color-primary)';
      btn.style.color = 'var(--color-primary)';
      btn.style.background = 'white';
    }
    // If checkbox is checked and variant changed, swap in cart
    var checkbox = document.getElementById('orderBumpCheck');
    if (checkbox && checkbox.checked && oldVariantId !== variantId) {
      var cartXhr = new XMLHttpRequest();
      cartXhr.open('GET', '/cart.js', true);
      cartXhr.setRequestHeader('Content-Type', 'application/json');
      cartXhr.onload = function() {
        if (cartXhr.status === 200) {
          try {
            var cart = JSON.parse(cartXhr.responseText);
            var bumpProductId = parseInt(document.getElementById('orderBump').dataset.productId);
            var oldItem = cart.items.find(function(item) { return item.product_id === bumpProductId; });
            if (oldItem) {
              var rmXhr = new XMLHttpRequest();
              rmXhr.open('POST', '/cart/change.js', true);
              rmXhr.setRequestHeader('Content-Type', 'application/json');
              rmXhr.onload = function() {
                var addXhr = new XMLHttpRequest();
                addXhr.open('POST', '/cart/add.js', true);
                addXhr.setRequestHeader('Content-Type', 'application/json');
                addXhr.onload = function() { fetchCart(); };
                var addItem = { id: variantId, quantity: 1 };
                if (_bumpCompare > _bumpPrice) {
                  yellaSavePricing(variantId, { c: parseInt(_bumpCompare, 10) || 0, s: '', p: 0, i: 0 });
                }
                addXhr.send(JSON.stringify({ items: [addItem] }));
              };
              rmXhr.send(JSON.stringify({ id: oldItem.key, quantity: 0 }));
            }
          } catch(e) {}
        }
      };
      cartXhr.send();
    }
  }

  function toggleOrderBump(checkbox) {
    if (checkbox.checked) {
      var bumpEl = document.getElementById('orderBump');
      var bumpCompare = bumpEl ? parseFloat(bumpEl.dataset.compare) : 0;
      var bumpPrice = bumpEl ? parseFloat(bumpEl.dataset.firstPrice) : 0;
      var itemData = { id: _bumpVariantId, quantity: 1 };
      if (bumpCompare > bumpPrice) {
        yellaSavePricing(_bumpVariantId, { c: parseInt(bumpCompare, 10) || 0, s: '', p: 0, i: 0 });
      }
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function() { fetchCart(); };
      xhr.send(JSON.stringify({ items: [itemData] }));
    } else {
      var bumpEl = document.getElementById('orderBump');
      var bumpProductId = parseInt(bumpEl.dataset.productId);
      var cartXhr = new XMLHttpRequest();
      cartXhr.open('GET', '/cart.js', true);
      cartXhr.setRequestHeader('Content-Type', 'application/json');
      cartXhr.onload = function() {
        if (cartXhr.status === 200) {
          try {
            var cart = JSON.parse(cartXhr.responseText);
            var bumpItem = cart.items.find(function(item) { return item.product_id === bumpProductId; });
            if (bumpItem) {
              var removeXhr = new XMLHttpRequest();
              removeXhr.open('POST', '/cart/change.js', true);
              removeXhr.setRequestHeader('Content-Type', 'application/json');
              removeXhr.onload = function() { fetchCart(); };
              removeXhr.send(JSON.stringify({ id: bumpItem.key, quantity: 0 }));
            }
          } catch(e) {}
        }
      };
      cartXhr.send();
    }
  }

  // Overwrite global stubs with real implementations
  window.selectBumpVariant = selectBumpVariant;
  window.toggleOrderBump = toggleOrderBump;

  function renderCartUpsell(cart) {
    var bumpEl = document.getElementById('orderBump');
    if (!bumpEl) return;
    var bumpProductId = parseInt(bumpEl.dataset.productId);
    if (!bumpProductId) { bumpEl.classList.add('hidden'); return; }

    // Move bump OUT of scroll area, place it before footer (once)
    var footerEl = document.getElementById('cartDrawerFooter');
    if (bumpEl.parentNode && bumpEl.parentNode.id === 'cartDrawerScroll' && footerEl) {
      footerEl.parentNode.insertBefore(bumpEl, footerEl);
    }

    var hasItems = cart.items.length > 0;
    var inCart = cart.items.some(function(item) { return item.product_id === bumpProductId; });
    bumpEl.classList.toggle('hidden', !hasItems);
    bumpEl.style.flexShrink = '0';
    var checkbox = document.getElementById('orderBumpCheck');
    if (checkbox) checkbox.checked = inCart;
  }

  function addUpsellToCart() {
    if (_bumpVariantId) addToCart(_bumpVariantId);
  }

  // === Popup Modal ===
  function initPopupModal() {
    var modal = document.getElementById('popupModal');
    if (!modal || !window._popupConfig) return;
    if (getCookie('popup_dismissed')) return;
    var config = window._popupConfig;
    var shown = false;

    function showPopup() {
      if (shown || getCookie('popup_dismissed')) return;
      shown = true;
      window._popupShown = true;
      modal.style.display = 'flex';
      requestAnimationFrame(function() { modal.classList.add('visible'); });
    }

    if (config.trigger === 'exit_intent' || config.trigger === 'both') {
      document.addEventListener('mouseout', function(e) {
        if (e.clientY < 5) showPopup();
      });
    }
    if (config.trigger === 'timed' || config.trigger === 'both') {
      setTimeout(showPopup, config.delay);
    }
  }

  function closePopupModal() {
    var modal = document.getElementById('popupModal');
    if (modal) {
      modal.classList.remove('visible');
      setTimeout(function() { modal.style.display = 'none'; }, 300);
      setCookie('popup_dismissed', '1', 1);
    }
  }

  function handlePopupSubmit(e) {
    e.preventDefault();
    var form = e.target;
    var formData = new FormData(form);
    fetch('/contact', { method: 'POST', body: formData }).catch(function() {});
    document.getElementById('popupForm').classList.add('hidden');
    document.getElementById('popupSuccess').classList.remove('hidden');
    setTimeout(closePopupModal, 4000);
  }

  // === Back-to-Top ===
  function initBackToTop() {
    var btn = document.getElementById('backToTopBtn');
    if (!btn) return;
    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // === Image Zoom ===
  function initImageZoom() {
    var container = document.querySelector('.hero-gallery');
    var img = document.getElementById('heroProductImg');
    if (!container || !img) return;
    if ('ontouchstart' in window) {
      container.style.touchAction = 'pan-y pinch-zoom';
      return;
    }
    container.style.cursor = 'zoom-in';
    var zoomTicking = false;
    container.addEventListener('mousemove', function(e) {
      if (zoomTicking) return;
      zoomTicking = true;
      requestAnimationFrame(function() {
        var rect = container.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(2.5)';
        zoomTicking = false;
      });
    });
    container.addEventListener('mouseleave', function() {
      img.style.transform = 'scale(1)';
    });
  }

  // === Page Transitions ===
  function initPageTransitions() {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript') || href.startsWith('mailto') || href.startsWith('tel')) return;
      if (link.target === '_blank' || link.hasAttribute('download')) return;
      if (link.hostname && link.hostname !== window.location.hostname) return;
      if (href.indexOf('/checkout') !== -1 || href.indexOf('/cart') !== -1) return;
      var main = document.querySelector('.page-transition');
      if (!main) return;
      e.preventDefault();
      main.classList.add('fade-out');
      setTimeout(function() { window.location.href = href; }, 300);
    });
  }

  // === Skeleton Loading ===
  function initSkeletonLoading() {
    var heroImg = document.getElementById('heroProductImg');
    var skeleton = document.getElementById('heroSkeleton');
    if (!heroImg || !skeleton) return;
    function hideSkeleton() { skeleton.classList.add('hidden'); }
    if (heroImg.complete) { hideSkeleton(); }
    else { heroImg.addEventListener('load', hideSkeleton); }
  }

  // === Cookie Helpers ===
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  // === Initialize ===
  document.addEventListener('DOMContentLoaded', () => {
    // Set default bundle
    currentBundleEl = document.querySelector('.bundle-card.active');
    if (currentBundleEl) {
      selectedVariantId = parseInt(currentBundleEl.dataset.variantId);
      yellaEcommerce('view_item', [yellaItemFromEl(currentBundleEl)]);
    }

    initScrollBehaviors();
    initRevealAnimations();
    initCounters();
    initVideoStories();
    initAnnouncementBar();
    // initCountdownTimer(); // Disabled: evergreen fake urgency violates Google Merchant misrepresentation policy
    // initSocialProofToasts(); // Disabled: fake purchase notifications violate Google Merchant misrepresentation policy
    initPopupModal();
    initBackToTop();
    // initImageZoom(); // Disabled: zoom on hover distracting
    initPageTransitions();
    initSkeletonLoading();
    fetchCart();
  });

  // Escape key closes cart drawer + popup
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closePopupModal();
    }
  });

  // Expose to global scope for onclick handlers in Liquid
  window.selectBundle = selectBundle;
  window.navigateHeroImage = navigateHeroImage;
  window.selectGalleryImage = selectGalleryImage;
  window.toggleFaq = toggleFaq;
  window.switchInfoTab = switchInfoTab;
  window.switchBATab = switchBATab;
  window.shopifyCheckout = shopifyCheckout;
  window.closeVideoModal = closeVideoModal;
  window.openVideoModal = openVideoModal;
  window.toggleMobileMenu = toggleMobileMenu;
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  window.updateCartItem = updateCartItem;
  window.removeCartItem = removeCartItem;
  window.dismissAnnouncement = dismissAnnouncement;
  window.dismissToast = window.dismissToast || function() {};
  window.toggleDiscountField = toggleDiscountField;
  window.applyDiscountCode = applyDiscountCode;
  window.addUpsellToCart = addUpsellToCart;
  window.fetchCart = fetchCart;
  window.formatMoney = formatMoney;
  window.closePopupModal = closePopupModal;
  window.handlePopupSubmit = handlePopupSubmit;
})();
